import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';

import App from '~/App';
import GlobalStyles from '~/styles/Global';
import Theme from '~/styles/Theme';

const root = document.getElementById('root');

ReactDOM.render(
  <ThemeProvider theme={Theme}>
    <>
      <GlobalStyles />
      <App />
    </>
  </ThemeProvider>,
  root
);

document.body.appendChild(root);
